"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AmazonIVSPlayer = require("./AmazonIVSPlayer");
Object.keys(_AmazonIVSPlayer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AmazonIVSPlayer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AmazonIVSPlayer[key];
    }
  });
});